"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var config_1 = require("../config");
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    default_1.prototype.render = function () {
        return (React.createElement("iframe", { src: "https://www.facebook.com/plugins/share_button.php" +
                ("?href=https%3A%2F%2F" + config_1.default.domain) +
                "&layout=button" +
                "&size=large" +
                "&mobile_iframe=true" +
                ("&appId=" + config_1.default.facebook.appId) +
                "&width=83" +
                "&height=28", width: 83, height: 28, style: { border: "none", overflow: "hidden" }, scrolling: "no", frameBorder: 0, allowTransparency: true }));
    };
    return default_1;
}(React.Component));
exports.default = default_1;



//////////////////
// WEBPACK FOOTER
// ./src/component/FacebookButton.tsx
// module id = 630
// module chunks = 0